import {
  Modal,
  Paper,
  Grid,
  Button,
  Typography,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { useState } from "react";

type Props = {
  open: boolean;
  handleOpen: () => void;
  handleConfirm: (hasDetail: boolean) => void;
};

export default function DetailConfirmationModal({
  open = true,
  handleOpen,
  handleConfirm,
}: Props) {
  const [hasDetail, setHasDetail] = useState<boolean>(true);
  return (
    <Modal open={open} onClose={handleOpen}>
      <Paper
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { sm: "90%", md: "30rem" },
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
        }}
      >
        <Grid container spacing={2}>
          <Typography variant="h5" gutterBottom>
            Exportar liquidación
          </Typography>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="body2" gutterBottom>
              Seleccione la siguiente opción para exportar:
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={hasDetail}
                  onChange={(e) => setHasDetail(e.target.checked)}
                  color="primary"
                />
              }
              label="Incluir detalle"
            />
          </Grid>
          <Grid item xs={12} display="flex" justifyContent="end" gap={1}>
            <Button
              type="button"
              variant="outlined"
              onClick={() => handleOpen()}
            >
              Cancelar
            </Button>
            <Button
              type="button"
              variant="contained"
              onClick={() => {
                handleConfirm(hasDetail);
                handleOpen();
              }}
            >
              Exportar
            </Button>
          </Grid>
        </Grid>
      </Paper>
    </Modal>
  );
}
